import React from 'react';
import { FiShield, FiTrendingUp, FiGlobe, FiAward } from 'react-icons/fi';
import useLanguage from '../../hooks/useLanguage';
import translationsData from '../../data/translations.json';
import Card from '../common/Card';

const ValueProposition = () => {
  const { language } = useLanguage();

  const sectionTitle = language === 'ko' ? translationsData.titles.ourValues : translationsData.titles.ourValuesEn;
  const values = translationsData.values;

  // Icon mapping
  const iconMap = [
    <FiTrendingUp className="w-12 h-12 text-blue-600" />,
    <FiShield className="w-12 h-12 text-blue-600" />,
    <FiGlobe className="w-12 h-12 text-blue-600" />,
    <FiAward className="w-12 h-12 text-blue-600" />
  ];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Title */}
        <div className="text-center mb-12" data-aos="fade-up">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {sectionTitle}
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
            <Card
              key={index}
              className="text-center p-8 hover:shadow-xl transition-all duration-300"
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              {/* Icon */}
              <div className="flex justify-center mb-4">
                <div className="p-4 bg-blue-50 rounded-full">
                  {iconMap[index]}
                </div>
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {language === 'ko' ? value.title : value.titleEn}
              </h3>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed">
                {language === 'ko' ? value.description : value.descriptionEn}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
